<template>
  <div id="marathon_videoCollectionSettingIndex" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="videoDemoArea">
      <div class="videoDemoList">
        <span
          class="videoDemo_item"
          v-for="item in videoTemplateArr"
          :key="item.templateId"
          :class="
            item.templateId == currVideoTemplate.templateId ? 'act' : 'noAct'
          "
          @click="clickVideoDemoItem(item)"
        >
          <videoAliplayerV2
            :options="{
              source: item.previewMedia ? item.previewMedia : '',
              cover: item.coverPhoto ? item.coverPhoto : null,
            }"
          ></videoAliplayerV2>
          <span class="opreaArea">
            <span
              class="opreaArea_btn el-icon-edit-outline"
              @click="editItem(item)"
            ></span>
            <span
              class="opreaArea_btn el-icon-close"
              @click="delItem(item)"
            ></span>
          </span>
        </span>
        <span class="add_item" @click="clickAddCamera">
          <span class="centerArea">
            <span class="centerArea_icon">
              <i class="el-icon-plus"></i>
            </span>
            <span class="centerArea_title" v-text="'添加模版'"></span>
          </span>
        </span>
      </div>
    </div>
    <div class="dataList">
      <span
        class="dataList_item"
        v-for="(item, index) in videoParamsArr"
        :key="index"
      >
        <span class="item_main" v-if="item.type === 'SelectClip'">
          <div class="dataList_item_row">
            <span v-text="'参数类型：'"></span>
            <span class="row_right_item" v-text="item.name"></span>
          </div>
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
          >
            <span v-text="'选择切片：'"></span>
            <div class="row_right_item">
              <el-select
                v-model="item.clipStream"
                popper-class="popup_select_opt"
                :popper-append-to-body="false"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addCamerKmArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
          >
            <span v-text="'偏移时间：'"></span>
            <div class="row_right_item">
              <el-input-number v-model="item.clipOffset" />
              <span class="ceil" v-text="'秒'"></span>
            </div>
          </div>
          <div class="dataList_item_row" v-if="item.duration">
            <span v-text="`${item.name}时长：`"></span>
            <span class="row_right_item" v-text="`${item.duration}秒`"></span>
          </div>
        </span>
        <span
          class="item_main"
          v-if="
            item.type === 'uploadImage' ||
            item.type === 'uploadVideo' ||
            item.type === 'uploadAudio'
          "
        >
          <div class="dataList_item_row">
            <span v-text="'参数类型：'"></span>
            <span class="row_right_item" v-text="item.name"></span>
          </div>
          <!-- <div class="dataList_item_row" v-if="item.oldParamValue">
            <span v-text="'当前文件：'"></span>
            <span class="row_right_item">
              <div
                v-if="item.type === 'uploadVideo'"
                style="width: 4.86vw; height: 4.86vw"
              >
                <video
                  :src="item.oldParamValue"
                  style="width: 4.86vw; height: 4.86vw"
                  controls="controls"
                >
                  您的浏览器不支持播放器
                </video>
              </div>
            </span>
          </div> -->
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
          >
            <span v-text="'选择文件：'"></span>
            <div class="row_right_item">
              <uploadFileList
                :axiosBaseUrl="axiosBaseUrl"
                :item="{
                  value: item.paramValue,
                  key: item.paramKey,
                }"
                :limitNum="1"
                :uploadType="item.type"
                :uploadTextTip="item.textTip"
                @submitImageEvent="submitImageEventHandler"
              />
            </div>
          </div>
          <div class="dataList_item_row" v-if="item.duration">
            <span v-text="`${item.name}时长：`"></span>
            <span class="row_right_item" v-text="`${item.duration}秒`"></span>
          </div>
        </span>
        <!-- <span class="item_main" v-if="item.type === 'TextFild'">
          <div class="dataList_item_row">
            <span v-text="'参数名称：'"></span>
            <span class="row_right_item" v-text="item.paramComment"></span>
          </div>
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
          >
            <span v-text="'文件路径：'"></span>
            <div class="row_right_item" v-text="item.oldParamValue"></div>
          </div>
        </span> -->
        <span class="item_main" v-if="item.type === 'TextInput'">
          <div class="dataList_item_row">
            <span v-text="'参数类型：'"></span>
            <span class="row_right_item" v-text="item.name"></span>
          </div>
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
          >
            <span v-text="'文字区域：'"></span>
            <div class="row_right_item">
              <el-input
                v-model="item.paramValue"
                :autosize="{ minRows: 3, maxRows: 4 }"
                type="textarea"
                :maxlength="30"
                :show-word-limit="30 > 0"
                :placeholder="
                  item.maxlength ? `请输入最多${item.maxlength}个字` : '请输入'
                "
              />
            </div>
          </div>
          <div class="dataList_item_row" v-if="item.duration">
            <span v-text="`${item.name}时长：`"></span>
            <span class="row_right_item" v-text="`${item.duration}秒`"></span>
          </div>
        </span>
        <!-- <span class="item_main" v-if="item.type === 'Image'">
          <div class="dataList_item_row">
            <span v-text="'参数名称：'"></span>
            <span class="row_right_item" v-text="item.paramComment"></span>
          </div>
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
          >
            <span v-text="'图片预览：'"></span>
            <div class="row_right_item">
              <el-image
                style="width: 100px; height: 100px"
                :src="'https://hyper-sports-dev-res.mixtmt.com/marathons/10001/templates/909da47126fe41368ec94121a9fcb7f7/cover.png?Expires=1682306636&OSSAccessKeyId=LTAI5tCf2xcTjyTbrmtpUtVX&Signature=lY0nJ8XnFuugORvuNq7hGSpZeTA%3D'"
                :preview-src-list="['https://hyper-sports-dev-res.mixtmt.com/marathons/10001/templates/909da47126fe41368ec94121a9fcb7f7/cover.png?Expires=1682306636&OSSAccessKeyId=LTAI5tCf2xcTjyTbrmtpUtVX&Signature=lY0nJ8XnFuugORvuNq7hGSpZeTA%3D']"
              ></el-image>
            </div>
          </div>
          <div
            class="dataList_item_row"
            :class="item.className ? item.className : ''"
            v-if="item.width && item.heigth"
          >
            <span v-text="'图片尺寸：'"></span>
            <div
              class="row_right_item"
              v-text="`${item.width}x${item.heigth}（宽x高；单位：px）`"
            ></div>
          </div>
        </span> -->

        <span class="item_btns">
          <span class="title" v-text="item.paramComment"></span>
        </span>
      </span>
    </div>
    <div class="opreaBtns" v-show="videoParamsArr && videoParamsArr.length > 0">
      <span
        class="opreaBtns_save"
        v-text="'保存'"
        @click="saveVideoParams()"
      ></span>
    </div>
    <Popup
      :closeEvent="closePopup"
      v-if="popupShow"
      :popTitle="popTitle"
      :popOpraBtns="popOpraBtns"
      :contentWidth="contentWidth"
    >
      <template #webmaster_popup>
        <!-- 添加|修改模版 -->
        <div
          class="group_popup"
          v-if="popState === 'addVideoDemo' || popState === 'editVideoDemo'"
        >
          <div
            class="group_popup_row"
            :class="keyItem.className ? keyItem.className : ''"
            v-for="keyItem in popUp_keyArr"
            :key="keyItem.key"
          >
            <span v-if="keyItem.isRequest" v-text="`*${keyItem.name}`"></span>
            <span v-else v-text="keyItem.name"></span>
            <div class="row_right_item" v-if="keyItem.type === 'String'">
              <el-input
                v-model="addCamerObj[keyItem.key]"
                :placeholder="`请输入${keyItem.name}`"
              ></el-input>
            </div>
            <div class="row_right_item" v-if="keyItem.type === 'textarea'">
              <el-input
                v-model="addCamerObj[keyItem.key]"
                :placeholder="`请输入${keyItem.name}`"
                :type="keyItem.type"
                :autosize="{ minRows: 2, maxRows: 6 }"
              ></el-input>
            </div>
            <div class="row_right_item" v-if="keyItem.type === 'Select'">
              <el-select
                v-model="addCamerObj[keyItem.key]"
                popper-class="popup_select_opt"
                :popper-append-to-body="false"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in addCamerKmArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <div class="row_right_item" v-else-if="keyItem.type === 'Time'">
              <el-input-number v-model="addCamerObj[keyItem.key]" />
              <span class="ceil" v-text="'秒'"></span>
            </div>
            <div
              class="row_right_item"
              v-else-if="
                keyItem.type === 'uploadImage' || keyItem.type === 'uploadVideo'
              "
            >
              <uploadFileList
                :item="{
                  value: addCamerObj[keyItem.key],
                  key: keyItem.key,
                }"
                :limitNum="1"
                :uploadType="keyItem.type"
                :uploadTextTip="keyItem.textTip"
                @submitImageEvent="submitImageEventHandler"
              />
            </div>
            <div
              class="row_right_item flexColumn"
              v-else-if="keyItem.type === 'Checkbox'"
            >
              <el-checkbox
                :indeterminate="checkBoxObj.isIndeterminate"
                v-model="checkBoxObj.checkAll"
                @change="handleCheckAllChange"
              >
                全选
              </el-checkbox>
              <el-checkbox-group
                v-model="checkBoxObj.serviceItems"
                @change="handleCheckedGroupChange"
              >
                <el-checkbox
                  v-for="item in checkBoxObj.serviceItemsArr"
                  :label="item.name"
                  :key="item.id"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <div class="group_popup_warning" v-show="warningText">
            <span>*</span>
            <span v-text="warningText"></span>
          </div>
        </div>
        <!-- 删除视频模版 -->
        <div class="group_popup" v-if="popState === 'delVideoItem'">
          <div class="group_popup_delete_tit">
            该视频模版将从数据库中彻底删除
          </div>
          <div class="group_popup_delete_wraning">
            您确定删除
            <span
              v-text="
                addCamerObj ? `【${addCamerObj[popUp_keyArr[0].key]}】` : ''
              "
            ></span>
            吗？
          </div>
        </div>
        <!-- 是否切换赛事类型 -->
        <div class="group_popup" v-if="popState === 'isChangeMarathonType'">
          <div class="group_popup_delete_tit">
            当前模版参数已修改，您确定切换赛事类型吗？
          </div>
        </div>
        <!-- 保存单个视频模版参数 -->
        <div class="group_popup" v-if="popState === 'saveVideoParams'">
          <!-- <div class="group_popup_delete_tit">
            该视频模版将从数据库中彻底删除
          </div> -->
          <div class="group_popup_delete_wraning">
            您确定保存
            <span
              v-text="
                currVideoTemplate ? `【${currVideoTemplate.templateName}】` : ''
              "
            ></span>
            吗？
          </div>
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import {
  https_marathon_stageteammenu,
  https_marathon_videoTemplateList,
  https_marathon_videoTemplateParamsDetail,
  https_marathon_cameraList,
  https_marathon_removeVideoTemplateItem,
  https_marathon_videoTemplateItemDetail,
  https_marathon_updateVideoTemplateParamsDetail,
  https_marathon_addVideoTemplateItem,
  https_marathon_updateVideoTemplateItem,
} from '@api/platfrom_marathon_api'
import videoAliplayerV2 from '@components/base/video_aliplayer_v2.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import Popup from '@components/base/base_popup.vue'
import uploadFileList from '@/components/base/uploadFileList.vue'
export default {
  name: 'marathon_videoCollectionSettingIndex',
  components: {
    marathon_select_opt,
    Popup,
    uploadFileList,
    videoAliplayerV2,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      loading: false,
      popUp_keyArr: [
        {
          name: '模版名称',
          key: 'templateName',
          isRequest: true,
          isShowText: true,
          type: 'String',
          ceil: '',
        },
        {
          name: '上传视频demo',
          key: 'previewMedia',
          isRequest: true,
          isShowText: true,
          type: 'uploadVideo',
          ceil: '',
          className: 'alignItemsStart',
          textTip: '', // 上传视频提示
        },
        {
          name: '模版配置',
          key: 'templateConfig',
          isRequest: true,
          isShowText: false,
          type: 'textarea',
          ceil: '',
          className: 'alignItemsStart',
        },
        // {
        //   name: '输出路径',
        //   key: 'streamAddress',
        //   isRequest: true,
        //   isShowText: true,
        //   type: 'String',
        //   ceil: '',
        // },
        {
          name: '视频封面',
          key: 'coverPhoto',
          isRequest: false,
          isShowText: true,
          type: 'uploadImage',
          ceil: '',
          className: 'alignItemsStart',
          textTip: '', // 上传图片提示
        },
        {
          name: '服务项目',
          key: 'projectCodes',
          isRequest: true,
          isShowText: true,
          type: 'Checkbox',
          ceil: '',
          className: 'alignItemsStart',
        },
      ],
      addCamerKmArr: [],
      checkBoxObj: {
        checkAll: false,
        serviceItems: [],
        isIndeterminate: false,
        serviceItemsArr: [
          // {
          //   id: 1,
          //   name: '上海',
          // },
          // {
          //   id: 2,
          //   name: '北京',
          // },
          // {
          //   id: 3,
          //   name: '广州',
          // },
          // {
          //   id: 4,
          //   name: '深圳',
          // },
        ],
      },
      videoTemplateArr: [],
      videoParamsArr: [],
      currVideoTemplate: {},
      tableTotal: 0,
      currStageMarathon: '',
      marathonTypeArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'marathonType',
            title: '赛事类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'marathonTypeArr',
          },
        ],
        selectOpt_list: [],
      },
      contentWidth: '56%',
      popupShow: false,
      popTitle: '添加摄像机位',
      popState: '',
      addCamerObj: null,
      opOpraBtns: [],
      warningText: '',
    }
  },
  created() {
    this.init()
  },
  computed: {
    noMore() {
      const curdataListNum = this.dataList ? this.dataList.length : -1
      return (
        curdataListNum >= this.tableTotal &&
        this.tableTotal !== 0 &&
        this.isScrollBottom
      )
    },
    noData() {
      return (
        this.tableTotal === 0 && this.dataList && this.dataList.length === 0
      )
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      await this.getstageMarathon()
      // this.dataList = [
      //   {
      //     id: 1,
      //     name: '出发点',
      //     code: '',
      //     streamAddress:
      //       'rtmp://111583.livepush.myqcloud.com/trtc_1400439699/live_2042479925028144202?txSecret=3a3e34dc176c11011df52f2f6c54fa5a&txTime=63BA55FB',
      //     streamingAddress:
      //       'rtmp://111583.livepush.myqcloud.com/trtc_1400439699/live_2042479925028144202?txSecret=3a3e34dc176c11011df52f2f6c54fa5a&txTime=63BA55FB',
      //     timingBlanket: '5',
      //     offsetTime: 1,
      //     serviceItems: ['全马', '半马'],
      //     nextTime: 1,
      //   },
      //   {
      //     id: 2,
      //     name: '出发点1',
      //     code: '',
      //     streamAddress: 'https://hyper-sports.mixtmt.com/broadcastList/index',
      //     streamingAddress: '',
      //     timingBlanket: '10',
      //     offsetTime: 1,
      //     serviceItems: ['全马', '半马'],
      //     nextTime: 1,
      //   },
      // ]
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickVideoDemoItem(curItem) {
      console.debug(curItem)
      this.videoTemplateArr.forEach((item) => {
        if (item.templateId === curItem.templateId) {
          this.currVideoTemplate = item
          this.getVideoTemplateParamsDetail()
        }
      })
    },
    submitImageEventHandler(data) {
      console.debug('图片生产的oss在线连接:', data)
      if (this.popupShow) {
        if (data.uploadFileItem.key === 'coverPhoto') {
          this.addCamerObj.coverPhoto = data.fullOssUrl
          this.addCamerObj.coverPhoto_absOssUrl = data.absOssUrl
        } else if (data.uploadFileItem.key === 'previewMedia') {
          this.addCamerObj.previewMedia = data.fullOssUrl
          this.addCamerObj.previewMedia_absOssUrl = data.absOssUrl
        }
      } else if (data.uploadFileItem.key) {
        this.videoParamsArr.forEach((item) => {
          if (data.uploadFileItem.key === item.paramKey) {
            item.paramValue_absOssUrl = data.absOssUrl
            item.paramValue = data.fullOssUrl
          }
        })
        console.debug('videoParamsArr:', this.videoParamsArr, this.addCamerObj)
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[0][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[0][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          const saveArr = this.checkOutIsUpdateCurVideoParams()
          this.changeValPathArr = valPathArr
          if (saveArr.length > 0) {
            this.isChangeMarathonType()
          } else {
            this.changeMarathonTypeHandler()
          }
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    isChangeMarathonType() {
      this.contentWidth = '40%'
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.cancelChangeMarathonTypeHandler,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.changeMarathonTypeHandler,
          btnStyle: '',
        },
      ]
      this.popState = 'isChangeMarathonType'
      this.popTitle = '提示'
      this.popupShow = true
    },
    changeMarathonTypeHandler() {
      const valPathArr = this.changeValPathArr
      if (valPathArr[0] === 'marathonType') {
        this.currStageMarathon = valPathArr[1]
      }
      this.syncSelectData()
      this.closePopup()
      this.getVideoTemplate()
    },
    cancelChangeMarathonTypeHandler() {
      this.changeValPathArr = []
      this.syncSelectData()
      this.closePopup()
    },
    syncSelectData() {
      let selectOpt_list = this.selectOptData.selectOpt_list
      selectOpt_list.forEach((item) => {
        if (item.type === 'marathonType') {
          item.list.forEach((marathonItem) => {
            if (marathonItem.value === this.currStageMarathon) {
              item.curId = marathonItem.value
              item.curVal = marathonItem.name
            }
          })
        }
      })
      this.selectOptData.selectOpt_list = selectOpt_list
    },
    async getstageMarathon() {
      await https_marathon_stageteammenu(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.marathonTypeArr = res.data ? res.data : []
            this.currStageMarathon = res.data[0] ? res.data[0].value : ''
            this.checkBoxObj.serviceItemsArr = res.data
              ? res.data.map((item) => {
                  return {
                    id: item.value,
                    name: item.name,
                  }
                })
              : []
            this.getVideoTemplate()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getCameraList() {
      let params = {
        matchId: this.currSid,
        code: this.currStageMarathon ? this.currStageMarathon : '',
      }
      await https_marathon_cameraList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.addCamerKmArr = res.data
              ? res.data.map((item) => {
                  return {
                    id: item.streamId,
                    name: item.streamName,
                  }
                })
              : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getVideoTemplate() {
      await this.getCameraList()
      let params = {
        matchId: this.currSid,
        code: this.currStageMarathon,
      }
      await https_marathon_videoTemplateList(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.videoTemplateArr = res.data ? res.data : []
            if (this.videoTemplateArr.length > 0) {
              this.currVideoTemplate = this.videoTemplateArr[0]
              this.getVideoTemplateParamsDetail()
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getVideoTemplateParamsDetail(templateId) {
      let params = {
        matchId: this.currSid,
        tplId: templateId ? templateId : this.currVideoTemplate.templateId,
      }
      await https_marathon_videoTemplateParamsDetail(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.videoParamsArr = res.data.map((item, index) => {
              let obj = item
              obj.oldParamValue = item.paramValue
              obj.oldParamKey = item.paramKey
              obj.paramValue_absUrl = ''
              obj.oldClipOffset = item.clipOffset
              obj.oldClipStream = item.clipStream
              if (obj.paramType === 'Video') {
                obj.name = '视频'
                obj.textTip = '' //提示...
                obj.type = 'uploadVideo'
                obj.className = 'alignItemsStart'
                // obj.paramValue = '//player.alicdn.com/video/editor.mp4'
              } else if (obj.paramType === 'Image') {
                obj.name = '图片'
                obj.textTip = '' //提示...
                obj.type = 'uploadImage'
                // obj.type = 'Image'
                obj.className = 'alignItemsStart'
              } else if (obj.paramType === 'Audio') {
                obj.name = '音频'
                obj.textTip = '' //提示...
                obj.type = 'uploadAudio'
                obj.className = 'alignItemsStart'
              } else if (obj.paramType === 'Clip') {
                obj.name = '切片'
                obj.textTip = '' // 提示...
                obj.type = 'SelectClip'
                obj.className = ''
              } else if (obj.paramType === 'Text') {
                obj.name = obj.paramName
                obj.textTip = '' // 提示...
                obj.type = 'TextInput'
                obj.className = 'alignItemsStart'
              } else {
                obj.name = '未定义'
                obj.textTip = '' //提示...
                obj.type = ''
                obj.className = ''
              }

              return obj
            })
            console.debug('videoParamsArr:', this.videoParamsArr)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    handleCheckAllChange(val) {
      console.debug('CheckAll:', val)
      this.checkBoxObj.serviceItems = val
        ? this.checkBoxObj.serviceItemsArr.map((item) => {
            return item.name
          })
        : []
      this.checkBoxObj.isIndeterminate = false
    },
    handleCheckedGroupChange(value) {
      console.debug('CheckedGroup:', value)
      let checkedCount = value.length
      this.checkBoxObj.checkAll =
        checkedCount === this.checkBoxObj.serviceItemsArr.length
      this.checkBoxObj.isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.checkBoxObj.serviceItemsArr.length
    },
    clickAddCamera() {
      this.initAddVideoPopup()
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '保存',
          btnEvent: this.saveSubmit,
          btnStyle: '',
        },
        {
          btnTitle: '保存继续添加',
          btnEvent: this.GoOnsaveSubmit,
          btnStyle: '',
        },
      ]
      this.popState = 'addVideoDemo'
      this.popTitle = '添加视频模版'
      this.popupShow = true
    },
    editItem(item) {
      this.popState = 'editVideoDemo'
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '保存',
          btnEvent: this.updateVideoTemplateSubmit,
          btnStyle: '',
        },
      ]
      this.popTitle = '编辑视频模版'
      this.addCamerObj = {}
      this.getVideoTemplateItemDetail(item)
      this.popupShow = true
    },
    delItem(item) {
      this.contentWidth = '40%'
      this.addCamerObj = item
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.removeSubmit,
          btnStyle: '',
        },
      ]
      this.popState = 'delVideoItem'
      this.popTitle = '删除视频模版'
      this.popupShow = true
    },
    saveVideoParams() {
      // 保存
      this.contentWidth = '40%'
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.saveVideoParamsSubmit,
          btnStyle: '',
        },
      ]
      this.popState = 'saveVideoParams'
      this.popTitle = '保存视频模版参数'
      this.popupShow = true
    },
    // 关闭弹窗
    closePopup() {
      this.popupShow = false
      this.contentWidth = '56%'
    },
    marathonTypeToMarathonName(arr) {
      let projectCodes = arr.map((item) => {
        let val = ''
        console.debug(this.marathonTypeArr, item)
        this.marathonTypeArr.forEach((typeItem) => {
          if (typeItem.value === item) {
            val = typeItem.name
          }
        })
        return val
      })
      return projectCodes
    },
    initAddVideoPopup() {
      // 初始化添加视频模版对象
      let addCamerObj = {}
      let checkBoxObj = this.checkBoxObj
      checkBoxObj.serviceItems = []
      this.checkBoxObj = checkBoxObj
      this.popUp_keyArr.forEach((key) => {
        if (
          key.type === 'String' ||
          key.type === 'Select' ||
          key.type === 'textarea'
        ) {
          addCamerObj[key.key] = ''
        } else if (key.type === 'Time') {
          addCamerObj[key.key] = 0
        } else if (key.type === 'Checkbox') {
          addCamerObj[key.key] = []
        }
      })
      this.addCamerObj = addCamerObj
      this.warningText = ''
    },
    checkOutIsUpdateCurVideoParams() {
      // 检查当前视频模版参数是否更改过数据，切换赛事类型需要先检测再切换
      let saveArr = []
      this.videoParamsArr.forEach((item) => {
        let isPush = false
        if (item.paramType === 'Video') {
          if (
            item.paramValue_absOssUrl ||
            item.paramValue_absOssUrl === item.paramValue
          ) {
            isPush = true
          }
        } else if (item.paramType === 'Clip') {
          if (item.oldClipStream !== item.clipStream) {
            isPush = true
          } else {
            if (item.oldClipOffset === null && item.clipOffset === 0) {
            } else if (item.oldClipOffset !== item.clipOffset) {
              // 偏移时间为null可以理解为是0
              isPush = true
            }
          }
        } else if (item.paramType === 'Image') {
          if (
            item.paramValue_absOssUrl ||
            item.paramValue_absOssUrl === item.paramValue
          ) {
            isPush = true
          }
        } else if (item.paramType === 'Audio') {
          if (
            item.paramValue_absOssUrl ||
            item.paramValue_absOssUrl === item.paramValue
          ) {
            isPush = true
          }
        } else if (item.paramType === 'Text') {
          if (item.oldParamValue !== item.paramValue) {
            isPush = true
          }
        }
        if (isPush) {
          const {
            paramKey,
            paramValue,
            paramValue_absOssUrl,
            supportCustomization,
            clipStream,
            clipOffset,
          } = item
          saveArr.push({
            paramKey,
            paramValue:
              item.paramType === 'Video' ||
              item.paramType === 'Image' ||
              item.paramType === 'Audio'
                ? paramValue_absOssUrl
                : paramValue,
            supportCustomization,
            clipStream,
            clipOffset,
          })
        }
      })
      console.debug(this.videoParamsArr)
      return saveArr
    },
    async saveVideoParamsSubmit() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const saveArr = this.checkOutIsUpdateCurVideoParams()
      console.debug(saveArr)
      await https_marathon_updateVideoTemplateParamsDetail(
        this.axiosBaseUrl,
        this.$axios,
        {
          matchId: this.currSid,
          tplId: this.currVideoTemplate.templateId,
          postData: saveArr,
        }
      )
        .then((response) => {
          if (response) {
            const res = response.data
            console.debug(res)
            console.debug('保存成功')
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.closePopup()
            this.getVideoTemplateParamsDetail(this.currVideoTemplate.templateId)
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async removeSubmit() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_removeVideoTemplateItem(
        this.axiosBaseUrl,
        this.$axios,
        {
          matchId: this.currSid,
          tplId: this.addCamerObj.templateId,
        }
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('删除成功')
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.closePopup()
            this.getVideoTemplate()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getVideoTemplateItemDetail(curItem) {
      this.updateVideoTemplateObj = curItem
      console.debug(curItem)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_videoTemplateItemDetail(
        this.axiosBaseUrl,
        this.$axios,
        {
          matchId: this.currSid,
          tplId: curItem.templateId,
        }
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug(res)
            let addCamerObj = res.data
            if (addCamerObj.projectCodes) {
              let projectCodesArr = addCamerObj.projectCodes.split(',')
              let projectCodes =
                this.marathonTypeToMarathonName(projectCodesArr)
              addCamerObj.projectCodes = projectCodes
              let checkBoxObj = this.checkBoxObj
              checkBoxObj.serviceItems = projectCodes
              this.checkBoxObj = checkBoxObj
            }
            addCamerObj.coverPhoto_absOssUrl = addCamerObj.coverPhoto
            addCamerObj.previewMedia_absOssUrl = addCamerObj.previewMedia
            this.addCamerObj = addCamerObj
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async GoOnsaveSubmit() {
      await this.saveSubmit('goOn')
    },
    async saveSubmit(isGoOn) {
      console.debug(this.addCamerObj)
      if (this.checkBoxObj.serviceItems.length > 0) {
        this.addCamerObj.serviceItems = this.checkBoxObj.serviceItems
      } else {
        this.addCamerObj.serviceItems = null
      }

      if (!this.root_isTrue(this.addCamerObj.templateName)) {
        this.warningText = '请输入模版名称'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.previewMedia_absOssUrl)) {
        this.warningText = '请上传视频'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.templateConfig)) {
        this.warningText = '请输入模版配置'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.coverPhoto_absOssUrl)) {
        this.warningText = '请上传封面'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.serviceItems)) {
        this.warningText = '请选择服务项目'
        return
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_addVideoTemplateItem(
        this.axiosBaseUrl,
        this.$axios,
        {
          matchId: this.currSid,
          postData: {
            tName: this.addCamerObj.templateName,
            video: this.addCamerObj.previewMedia_absOssUrl,
            config: this.addCamerObj.templateConfig,
            pic: this.addCamerObj.coverPhoto_absOssUrl,
            code: this.addCamerObj.serviceItems
              .map((item) => {
                let value = ''
                this.marathonTypeArr.forEach((typeItem) => {
                  if (typeItem.name === item) {
                    value = typeItem.value
                  }
                })
                return value
              })
              .join(','),
          },
        }
      )
        .then((data) => {
          // console.debug(data)
          if (data) {
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success',
            })
            console.debug(isGoOn)
            if (isGoOn === 'goOn') {
              this.initAddVideoPopup()
            } else {
              this.closePopup()
            }
            this.getVideoTemplateParamsDetail(this.currVideoTemplate.templateId)
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    getAbsOssUrl(url) {
      let absUrl = url
      if (url.indexOf('http') === 0) {
        let fullUrl = url.split('?')[0]
        let pathUrlArr = fullUrl.split('//')[1].split('/')
        pathUrlArr.shift()
        absUrl = pathUrlArr.join('/')
      }
      console.debug('getAbsOssUrl:', absUrl)
      return absUrl
    },
    async updateVideoTemplateSubmit() {
      console.debug(this.addCamerObj)
      if (this.checkBoxObj.serviceItems.length > 0) {
        this.addCamerObj.serviceItems = this.checkBoxObj.serviceItems
      } else {
        this.addCamerObj.serviceItems = null
      }

      if (!this.root_isTrue(this.addCamerObj.templateName)) {
        this.warningText = '请输入模版名称'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.previewMedia_absOssUrl)) {
        this.warningText = '请上传视频'
        return
      } else {
        this.addCamerObj.previewMedia_absOssUrl = this.getAbsOssUrl(
          this.addCamerObj.previewMedia_absOssUrl
        )
      }
      if (!this.root_isTrue(this.addCamerObj.templateConfig)) {
        this.warningText = '请输入模版配置'
        return
      }
      if (!this.root_isTrue(this.addCamerObj.coverPhoto_absOssUrl)) {
        this.warningText = '请上传封面'
        return
      } else {
        this.addCamerObj.coverPhoto_absOssUrl = this.getAbsOssUrl(
          this.addCamerObj.coverPhoto_absOssUrl
        )
      }
      if (!this.root_isTrue(this.addCamerObj.serviceItems)) {
        this.warningText = '请选择服务项目'
        return
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_updateVideoTemplateItem(
        this.axiosBaseUrl,
        this.$axios,
        {
          matchId: this.currSid,
          tplId: this.updateVideoTemplateObj.templateId,
          postData: {
            tName: this.addCamerObj.templateName,
            video: this.addCamerObj.previewMedia_absOssUrl,
            config: this.addCamerObj.templateConfig,
            pic: this.addCamerObj.coverPhoto_absOssUrl,
            code: this.addCamerObj.serviceItems
              .map((item) => {
                let value = ''
                this.marathonTypeArr.forEach((typeItem) => {
                  if (typeItem.name === item) {
                    value = typeItem.value
                  }
                })
                return value
              })
              .join(','),
          },
        }
      )
        .then((data) => {
          // console.debug(data)
          if (data) {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
            this.closePopup()
            this.getVideoTemplate()
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
  },
}
</script>

<style lang="scss" scoped>
#marathon_videoCollectionSettingIndex {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .videoDemoArea {
    margin-top: 1.388vw;
    /* padding: 1.875vw 1.388vw; */
    width: 100%;
    height: 13.194vw;
    background-color: var(--mixtmt_mainColor6);
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    &::before,
    &::after {
      content: '\20';
      margin: 0 1.388vw;
      width: calc(100% - 1.388vw - 1.388vw);
      height: 0.694vw;
    }
    &::before {
      margin-bottom: 0.556vw;
      border-top: 0.694vw dashed var(--mixtmt_whiteColor);
    }
    &::after {
      margin-top: 0.556vw;
      border-bottom: 0.694vw dashed var(--mixtmt_whiteColor);
    }
    .videoDemoList {
      padding: 0 1.388vw;
      width: 100%;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      overflow: auto;
      overflow-y: hidden;
      .add_item,
      .videoDemo_item {
        position: relative;
        flex: none;
        width: 16.782vw;
        height: 9.444vw;
        &.act {
          border: 2px solid var(--mixtmt_mainColor8);
          .opreaArea {
            width: 6.94vw;
            height: 2.083vw;
          }
        }
        .opreaArea {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1000;
          width: 100%;
          height: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-end;
          align-items: flex-start;
          padding: 0.694vw;

          .opreaArea_btn {
            margin-left: 0.555vw;
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 50%;
            font-size: 0.833vw;
            background-color: var(--mixtmt_greyColor9);
            color: var(--mixtmt_greyColor3);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      .videoDemo_item {
        margin-right: 0.694vw;
        background-color: var(--mixtmt_greyColor4);
      }
      .add_item {
        background-color: var(--mixtmt_greyColor8);
      }
    }
  }

  .dataList {
    padding: 2.778vw 0;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    align-content: flex-start;
    .dataList_item {
      margin: 0 1.74vw 1.743vw 0;
      width: 39.406vw;
      height: 21.4vw;
      background-color: var(--mixtmt_greyColor8);
      border-radius: 0.556vw;
      &:nth-child(2n) {
        margin: 0 0 1.743vw 0;
      }
    }

    .dataList_item {
      position: relative;
      padding-top: 3.472vw;
      border: 1px solid var(--mixtmt_greyColor7);
      .item_main {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        padding: 1.388vw 1.388vw 0 1.388vw;
        width: 100%;
        height: 100%;
        background-color: var(--mixtmt_whiteColor);
        border-radius: 0 0 0.556vw 0.556vw;
        .dataList_item_row {
          width: 100%;
          margin-bottom: 1.388vw;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          &.alignItemsStart {
            align-items: flex-start;
            & > span {
              padding-top: 0.208vw;
            }
          }
          .row_right_item {
            flex: 1;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            &.flexColumn {
              flex-direction: column;
              align-items: flex-start;
            }
            .ceil {
              padding-left: 0.694vw;
              font-size: 0.972vw;
              font-weight: 600;
              color: var(--mixtmt_greyColor2);
            }
          }
          & > span {
            width: 6.94vw;
            padding-right: 0.694vw;
            text-align: right;
            font-size: 0.972vw;
            font-weight: 600;
            color: var(--mixtmt_greyColor2);
          }
        }
      }
      .item_btns {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 3.472vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .btn {
          margin-right: 1.388vw;
          width: 6.94vw;
          height: 1.94vw;
          border: none;
          border-radius: 0.138vw;
          font-size: 0.833vw;
          font-weight: 500;
          line-height: 1.94vw;
          text-align: center;
          background: var(--mixtmt_whiteColor);
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
        }
        .title {
          padding: 0 1.388vw;
          width: 100%;
          font-size: 0.972vw;
          font-weight: 500;
          line-height: 1.94vw;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }
  .opreaBtns {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
    padding-bottom: 4.62vw;
    .opreaBtns_save {
      width: 6.94vw;
      height: 2.778vw;
      line-height: 2.778vw;
      font-size: 1.11vw;
      text-align: center;
      background-color: var(--mixtmt_mainColor6);
      color: var(--mixtmt_whiteColor);
      border-radius: 0.2778vw;
    }
  }

  .add_item {
    position: relative;
    & .centerArea {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 10;
      width: 100%;
      padding: 10%;
      transform: translate(-50%, -50%);
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: var(--mixtmt_greyColor2);
      .centerArea_icon {
        font-size: 2.778vw;
      }
      .centerArea_title {
        font-size: 1.11vw;
        line-height: 2.778vw;
      }
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
  .group_popup {
    height: 100%;
    padding: 0.694vw;
    width: 90%;
    h1 {
      font-size: 1.25vw;
      color: var(--mixtmt_greyColor3);
    }
    .group_popup_row {
      margin-bottom: 1.388vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      &.alignItemsStart {
        align-items: flex-start;
        & > span {
          padding-top: 0.208vw;
        }
      }
      .row_right_item {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.flexColumn {
          flex-direction: column;
          align-items: flex-start;
        }
        .ceil {
          padding-left: 0.694vw;
          font-size: 0.972vw;
          font-weight: 600;
          color: var(--mixtmt_greyColor2);
        }
      }
      & > span {
        width: 8.333vw;
        padding-right: 0.694vw;
        text-align: right;
        font-size: 0.972vw;
        font-weight: 600;
        color: var(--mixtmt_greyColor2);
      }
    }
    .group_popup_warning {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 1.25vw;
      font-size: 0.8333vw;
      font-weight: 400;
      color: var(--mixtmt_errColor);
      line-height: 1.25vw;
      margin: 0.694vw 0;
    }
    .group_popup_btns {
      text-align: center;
      &:after {
        content: '';
        clear: both;
      }
    }
    .group_popup_cancel,
    .group_popup_save {
      display: inline-block;
      width: 8.333vw;
      height: 1.94vw;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.138vw;
      border: 1px solid rgba(220, 223, 230, 1);
      font-size: 0.833vw;
      font-weight: 500;
      color: rgba(90, 94, 102, 1);
      line-height: 1.94vw;
      cursor: pointer;
    }
    .group_popup_save {
      margin-left: 1.388vw;
      background: var(--mixtmt_mainColor6);
      color: rgba(255, 255, 255, 1);
      border: none;
      &:hover {
        background: var(--mixtmt_mainColor6);
      }
    }
    .group_popup_cancel {
      &:hover {
        border: 1px solid var(--mixtmt_mainColor6);
      }
    }
    // 删除弹框样式
    .group_popup_delete_tit {
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.25vw;
      text-align: center;
    }
    .group_popup_delete_wraning {
      margin: 1.388vw 0;
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.667vw;
      text-align: center;
      span {
        color: var(--mixtmt_errColor);
      }
    }
  }
}
.mixtmt_pc {
  #marathon_videoCollectionSettingIndex {
    .add_item,
    .videoDemo_item {
      cursor: pointer;
      &:hover {
        border: 2px solid var(--mixtmt_mainColor8);
      }
      .opreaArea {
        .opreaArea_btn {
          &:hover {
            color: var(--mixtmt_whiteColor);
            background-color: var(--mixtmt_mainColor8);
          }
        }
      }
    }
    .dataList {
      .dataList_item {
        .item_btns {
          .btn {
            cursor: pointer;
            &:hover {
              background: var(--mixtmt_mainColor6);
              border: 1px solid var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
            }
          }
        }
      }
    }
    .opreaBtns {
      .opreaBtns_save {
        &:hover {
          cursor: pointer;
          background-color: var(--mixtmt_mainColor8);
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dataList_item {
  .el-input__inner {
    height: 2.778vw;
    line-height: 2.778vw;
    border-radius: 0.278vw;
    padding: 0 1.041vw;
  }
  .el-select-dropdown {
    border-radius: 0.69vw;
  }
  .el-select-dropdown__item {
    font-size: 1.111vw;
    height: 2.778vw;
    line-height: 2.778vw;
    &.selected,
    &.hover,
    &.active,
    &.visited {
      color: var(--mixtmt_subColor1_1);
      background-color: var(--mixtmt_subColor1_2);
    }
  }
}
.videoDemo_item {
  &.noAct {
    .prism-big-play-btn {
      display: none !important;
    }
  }
}
</style>
